import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";

export const apiGetResource = async (fieldValues: {
  filter: {
    filter: string;
    module: string;
  };
}) => {
  try {
    const uri = `/admin/resources?filter=${fieldValues.filter.filter}&module=${fieldValues.filter.module}`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export interface CreatePermissionProp {
  name: string;
  path: any;
  description: any;
  privilege: {
    verbs: any;
  };
}

export const apiCreatePermission = async (
  fieldValues: CreatePermissionProp,
) => {
  const formData = JSON.stringify(fieldValues);

  try {
    const uri = `/admin/access/permission`;

    return await Axios.post(uri, formData);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetPermissions = async () => {
  try {
    const uri = `/admin/access/permissions`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetPermissionById = async (permissionId: string) => {
  try {
    const uri = `/admin/access/permission/${permissionId}`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetRoles = async () => {
  try {
    const uri = `/admin/access/roles`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetRolesById = async (roleId: string) => {
  try {
    const uri = `/admin/access/role/${roleId}`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiCreateRoles = async (fieldValues: {
  name: string;
  description: string;
}) => {
  const formData = JSON.stringify(fieldValues);

  try {
    const uri = `/admin/access/role`;

    return await Axios.post(uri, formData);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiRemovePermissionFromRole = async (
  roleId: string,
  data: EntryValue[],
) => {
  const permissions = data;
  const formData = JSON.stringify({ permissions });

  try {
    const uri = `/admin/access/roles/${roleId}/permissions`;

    return await Axios.patch(uri, formData);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};
export const apiDeleteRole = async (roleId: string) => {
  try {
    const uri = `/admin/access/role/${roleId}`;

    return await Axios.delete(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

type VerbDetail = {
  alias: string;
  descriptions: string;
};
type EntryValue = {
  key: string;
  path: string;
  description: string;
  privilege: {
    verbs: Record<string, VerbDetail>; // Allows any string keys for verbs
  };
};
export const apiAssignPermissionToRoles = async (
  fieldValues: EntryValue[],
  roleId: string,
) => {
  const data = {
    permissions: fieldValues,
  };
  const formData = JSON.stringify(data);

  try {
    const uri = `/admin/access/roles/${roleId}/permissions`;

    return await Axios.put(uri, formData);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetUserPermission = async () => {
  try {
    const uri = `/admin/access/user/:_id/permissions`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiAssignRolesToUsers = async (field: {
  userId: string;
  roleId: string[];
}) => {
  const formData = JSON.stringify({ roles: field.roleId });

  try {
    const uri = `/admin/access/user/${field.userId}/roles`;

    return await Axios.put(uri, formData);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiSuspendUserAccess = async (value: {
  userId: string;
  suspend: boolean;
}) => {
  try {
    const uri = `/admin/users/user/${value?.userId}/suspend`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.put(uri, { suspended: value.suspend }, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiDeleteUser = async (userId: string) => {
  try {
    const uri = `/admin/users/user/${userId}/delete`;

    return await Axios.delete(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};
